module.exports = __webpack_public_path__ + "img/RMB.4070741cb.svg";